/**
 * Super admin service  module
 */
import { requestData } from "../../utils";
export default class ServicesAPI {
  // constructor() {}
  getServiceAPIMonitoring({ service, cmd, filename, extra_params }) {
    return requestData("GET", `/monitoring/commands`, {
      service,
      cmd,
      params: { filename, extra_params },
    });
  }
  getServiceFile({ service, cmd, filename, extra_params }) {
    return requestData("GET", `/monitoring/commands`, {
      service,
      cmd,
      params: { filename, extra_params },
      responseType: 'stream',
      headers: {
        responseType: 'stream'
      }
    });
  }
  getServices() {
    return requestData("GET", `/services/list`);
  }
}
